import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ReportList() {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const r = await axios.get(`${API}/reports`, { withCredentials: true });
        setReports(r.data?.reports || []);
      } catch (e) {
        setError(e?.response?.data?.detail || "Failed to load reports");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="max-w-5xl mx-auto px-4 py-6" data-testid="report-list">
      <div className="flex items-center justify-between mb-4">
        <div>
          <div className="text-[10px] uppercase font-mono text-zinc-500">LLM Report Builder</div>
          <h1 className="text-xl font-semibold tracking-tight text-zinc-900">Saved reports</h1>
        </div>
        <Link to="/reports/new"
              className="px-3 py-1.5 rounded bg-emerald-700 hover:bg-emerald-800 text-white text-xs font-mono uppercase tracking-wider"
              data-testid="new-report-btn">+ New report</Link>
      </div>

      {loading && <div className="text-sm text-zinc-500">Loading…</div>}
      {error && <div className="text-sm text-red-700">{error}</div>}

      {!loading && reports.length === 0 && (
        <div className="border border-dashed border-zinc-300 rounded-lg p-8 text-center bg-zinc-50">
          <div className="text-sm text-zinc-600 mb-2">No reports yet.</div>
          <Link to="/reports/new" className="text-emerald-700 text-sm font-mono underline">Create your first report →</Link>
        </div>
      )}

      <div className="space-y-2">
        {reports.map((r) => (
          <Link key={r.report_id} to={`/reports/${r.report_id}`}
                className="block border border-zinc-200 rounded-lg p-3 bg-white hover:border-emerald-500 transition-colors"
                data-testid={`report-row-${r.report_id}`}>
            <div className="flex items-start gap-3">
              <div className="flex-1 min-w-0">
                <div className="text-sm font-medium text-zinc-900 truncate">{r.question}</div>
                <div className="mt-1 text-[11px] font-mono text-zinc-500 flex gap-3">
                  <span>{new Date(r.created_at).toLocaleString()}</span>
                  {r.context_ccn && <span>ccn {r.context_ccn}</span>}
                  {r.context_ein && <span>ein {r.context_ein}</span>}
                  <span>{(r.citations || []).length} citations</span>
                  {r.share_token && <span className="text-emerald-700">shared</span>}
                </div>
              </div>
              <div className={`text-[10px] font-mono px-2 py-0.5 rounded uppercase ${
                r.validation?.passed
                  ? "bg-emerald-100 text-emerald-800"
                  : "bg-amber-100 text-amber-800"
              }`}>
                {r.validation?.passed ? "verified" : "warnings"}
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
